import React from "react";
import { Box, Typography, Avatar, Button } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp'; // Icono de logout
const ConfigUser = ({ userSystem, isMobile, logout }) => {

    return (
        <Box >
            <Typography variant="h6">Ajustes</Typography>
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: 2,
                    gap: 4,
                }}
            >
                <Avatar
                    sx={{
                        width: !isMobile ? 180 : 120, // Ajusta el tamaño según lo necesites
                        height: !isMobile ? 180 : 120, // Ajusta el tamaño según lo necesites
                        marginRight: 1, // Espaciado entre la imagen y el texto
                    }}
                />
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            color: '#046455',
                            fontSize: '1rem',
                        }}
                    >
                        Tu nombre:
                    </Typography>
                    <Typography variant="h6" sx={{
                        color: '#fff',
                        fontSize: '1.5rem',
                    }}>{userSystem.name}</Typography>
                </Box>
                <Button sx={{
                    color: '#f00',
                    backgroundColor: 'none',
                    fontSize: '0.8rem',
                    padding: 2,
                    textTransform: 'none',
                    borderRadius: '3px',
                    border: '1px solid #f00',
                    cursor: 'pointer',
                    position: 'absolute',
                    bottom: 200,
                }}
                    onClick={logout}
                >
                    <ExitToAppIcon style={{ color: "#f00" }} />  {/* Cambia el color del ícono a blanco */}
                    <Typography sx={{
                        color: '#f00',
                    }}>Cerrar Sesion</Typography>
                </Button>
            </Box>
        </Box>
    )
}

export default ConfigUser;